/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { CittadinoMensaStudenteDTO } from '../model/models';
import { ExceptionResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';


import { Configuration }                                     from '../configuration';



export interface CittadinoStudentiMensaServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Lista cross-servizio degli studenti mensa del cittadino.
     * Audience: CITTADINO. Tutti gli studenti del caller su tutti i servizi mensa attivi (data_inizio &lt;&#x3D; oggi e data_fine assente o &gt;&#x3D; oggi) la cui Pratica origine è accettata, ciascuno col blocco servizio del comune di afferenza (servizio.id &#x3D; header Gestione-Mense-Servizio-Id degli step successivi) + servizio.tipo_pagamento (prepagato vs scadenza mensile). Ogni riga porta inoltre, quando disponibili: il blocco \&#39;portafogli\&#39; (residuo, costo_pasto, saldo_iniziale, pasti_usufruiti) e il blocco \&#39;pagamenti\&#39; (is_presente_ricarica_da_pagare, giorni_residui_sospensione_servizio). Semantica blocco-omesso: \&#39;portafogli\&#39; omesso &#x3D; studente senza portafogli; \&#39;pagamenti\&#39; omesso &#x3D; nessuna ricarica in attesa di pagamento (&#x3D; nessun pagamento dovuto). \&#39;giorni_residui_sospensione_servizio\&#39; è presente solo oltre la soglia promemoria e mai negativo. Lo stesso figlio su più servizi produce una riga per servizio. Lista non paginata, non ordinata server-side (ordinamento lato client).
     * @endpoint get /api/v1/cittadino/servizi/mensa-studenti
*/
    listMensaStudentiCittadino(extraHttpRequestParams?: any): Observable<Array<CittadinoMensaStudenteDTO>>;

}
